import axios from "axios";
import {
  FETCH_INVOICE_HISTORY_REQUEST,
  FETCH_INVOICE_HISTORY_SUCCESS,
  FETCH_INVOICE_HISTORY_FAILURE,
  FETCH_STATS_REQUEST,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
} from "./types";
import { INVOICE, INVOICE_HISTORY, PAYMENT_STATS } from "../api";

export const fetchInvoiceHistory = (data) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_INVOICE_HISTORY_REQUEST,
    });
    axios
      .post(INVOICE_HISTORY, data)
      .then((response) => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_SUCCESS,
          payload: response?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_INVOICE_HISTORY_FAILURE,
          payload: error.message,
        });
      });
  };
};
export const fetchPaymentRequestStats = (period, type, wallets) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_STATS_REQUEST,
    });
    axios
      .get(
        `${PAYMENT_STATS}/${type.key}?wallets=${wallets}&period=${period.value}`
      )
      .then((response) => {
        dispatch({
          type: FETCH_STATS_SUCCESS,
          payload: response?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_STATS_FAILURE,
          payload: error.message,
        });
      });
  };
};
export const fetchInvoice = (param) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_INVOICE_REQUEST,
    });
    axios
      .get(`${INVOICE}/${param}?expired=true&paid=true`)
      .then((response) => {
        dispatch({
          type: FETCH_INVOICE_SUCCESS,
          payload: response?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_INVOICE_FAILURE,
          payload: error.message,
        });
      });
  };
};
